import RiyalSymbol from "./RiyalSymbol";
import { fmtMoney } from "../lib/format";

/**
 * Money — official SAMA 2025 Riyal rendering.
 *
 * Renders the amount followed by the official Saudi Riyal SVG glyph.
 * Always uses English digits (via fmtMoney).
 *
 * Usage:
 *   <Money amount={1500} />
 *   <Money amount={1500} size={16} bold />
 */
export default function Money({
  amount,
  size = 13,
  color = "currentColor",
  bold = false,
  className = "",
  style = {},
}) {
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontFamily: "monospace",
        fontWeight: bold ? 900 : "inherit",
        whiteSpace: "nowrap",
        ...style,
      }}
      data-currency="SAR"
    >
      <span>{fmtMoney(amount)}</span>
      <RiyalSymbol size={size} color={color} />
    </span>
  );
}
